import axios from "axios";
import { getFromStorage, removeItemFromStorage } from "./storage";
import toast from "react-hot-toast";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE, // no trailing slash in .env
  headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getFromStorage("lmsCCToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error?.response?.data?.errorCode || error.response.status;
      if (status === 401) {
        removeItemFromStorage("lmsCCToken");
        removeItemFromStorage("lmsCCUser");
        window.location.href = "/?blocked=true";
      } else {
        const message = error.response.data?.message || "Something went wrong";
      }
    } else if (error.request) {
      console.log(error);
    } else {
      console.error(`Error: ${error.message}`);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
